export enum ApiResponseStatus {
  Success = 'success',
  Error = 'error',
}
